module.exports = __webpack_public_path__ + "img/team-04.3bcdf645.jpg";